import script from "./UiDataTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiDataTable.vue?vue&type=script&setup=true&lang=ts"

import "./UiDataTable.vue?vue&type=style&index=0&id=54feb8ac&lang=sass"

const __exports__ = script;

export default __exports__